import React, { useState, useRef, useEffect } from "react";
import { Col, Navbar, Button, Dropdown, InputGroup, FormControl } from 'react-bootstrap';
import { useNavigate, useLocation } from "react-router-dom";
import { Link } from 'react-router-dom';
import Header, { HeaderNav, Menu, MobileMenu,SearchBar ,HeaderNot} from '../../Components/Header/Header';
import { IMAGE_PATHS, DOMAIN_URL } from '../../Functions/Constant';
import API from '../../Api/Api';
import SearchHeaderForMob from '../Header/SearchHeaderForMob';
import HeaderData from "../../Components/Header/HeaderData"; // Import HeaderData

const MyHeader = (props, isSticky) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [userData, setUserData] = useState(null);
  const [jwtTokenJobcritic, setjwtTokenJobcritic] = useState(localStorage.getItem("jwt_token_jobcritic"));
  const [searchQuery, setSearchQuery] = useState(''); // Added state for search query
  const navigate = useNavigate();
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("Name");
  const location = useLocation();
  const [showMenu, setShowMenu] = useState(false)
  ;
  const dropdownRef = useRef(null);


  const fetchDataUser = async () => {
    try {
      const endpoint = `/user`;
      const res = await API.get(endpoint);
      if (res.user) {
        const userData = {
          name: res.user.name || "Unknown User",
          profile_image: res.user.profile_image ? DOMAIN_URL + res.user.profile_image : IMAGE_PATHS.USER,
          email: res.user.email || "Unknown User",

        };

        setUserData(userData);
        localStorage.setItem("userData", JSON.stringify(userData));
      }
    } catch (error) {
      const storedUserData = localStorage.getItem("userData");
      if (storedUserData && error.response.status == 401) {
        handleLogout();
      }
      console.error(error);
    } finally {
    }
  };
  // New function to handle search
  const handleSearch = () => {
    if (searchQuery.trim()) {
      let categoryValue = selectedCategory.toLowerCase();
      if (selectedCategory === "School/College") {
        categoryValue = "school";
      }
      navigate(`/search?query=${encodeURIComponent(searchQuery)}&category=${encodeURIComponent(categoryValue)}`);
      setSearchQuery('');
    }
  };

  // Handle Enter key press
  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };
  useEffect(() => {
    // document.querySelector("body").classList.remove("overflow-hidden");
    const storedUserData = localStorage.getItem("userData");
    if (storedUserData) {
      try {
        fetchDataUser();
        setUserData(JSON.parse(storedUserData));
      } catch (error) {
        console.error("Error parsing userData:", error);
        fetchDataUser();
      }
    } else {
      fetchDataUser();
    }

  }, []);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 27);
      const scrollY = window.scrollY;
      if (location.pathname === "/reviews") {
        const screenWidth = window.innerWidth;
        const scrollThreshold = screenWidth >= 991 ? 245 : 180;
        setShowSearchBar(window.scrollY >= scrollThreshold);
      }
      setShowDropdown(false);
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [location.pathname, showDropdown]);

  // Handle navigation for review button
  const handleReviewClick = () => {
    if (jwtTokenJobcritic) {
      navigate("/reviews");
    } else {
      navigate("/login");
    }
  };

  // Handle logout
  const handleLogout = () => {
    localStorage.clear();
    localStorage.removeItem("jwt_token_jobcritic");
    localStorage.removeItem("userData");
    setjwtTokenJobcritic(null);
    setUserData(null);
    window.location.href = "/";
  };
  const menuData = HeaderData(jwtTokenJobcritic) || [];
  // Render user dropdown for both desktop and mobile
  const renderUserDropdown = () => (
    <Dropdown className="ml-[1.3rem]">
      <Dropdown.Toggle as="div" className="cursor-pointer">
        <img
        crossorigin="anonymous"
          src={userData?.profile_image || IMAGE_PATHS.USER}
          alt="User"
          className="w-[40px] h-[40px] rounded-full object-cover border border-gray-300"
        />
      </Dropdown.Toggle>
      <Dropdown.Menu className="bg-white shadow-lg rounded-lg py-2 w-[270px] xs:!left-[-159px] xs:!w-[240px] md:!left-[-200px] !left-[-228px]">
        <div className="flex items-center space-x-3 px-4 py-3 border-b">
          <Link to="/profile">
            <img
            crossorigin="anonymous"
              src={userData?.profile_image || IMAGE_PATHS.USER}
              alt="User"
              className="w-[40px] h-[40px] rounded-full object-cover border border-gray-300"
            />
          </Link>
          <div>
            <Link to="/profile">
              <p className="text-gray-900 font-semibold text-sm">{userData?.name || "User Name"}</p>
            </Link>
            <Link to="/profile">
              <p className="text-gray-500 text-xs">{userData?.email || ""}</p>
            </Link>
          </div>
        </div>
        <Dropdown.Item as={Link} to="/settings" className="block px-4 py-2 text-gray-800 hover:bg-gray-100">
          Account Settings
        </Dropdown.Item>
        <div className="border-t my-2"></div>
        <Dropdown.Item as={Link} to="/contact_us" className="block px-4 py-2 text-gray-800 hover:bg-gray-100">
          Support
        </Dropdown.Item>
        <div className="border-t my-2"></div>
        <Dropdown.Item onClick={handleLogout} className="block px-4 py-2 text-gray-800 hover:bg-gray-100">
          Logout
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );


  return (
    <Header topSpace={{ md: true }} type="responsive-sticky">
      <HeaderNav theme="light" bg="white" expand="lg" className={`py-[0px] px-[35px] lg:px-[15px] md:px-[15px] md:py-[15px] sm:px-0 ${isScrolled && location.pathname !== '/profile' ? "shadow-md" : ""
        }`}>

        {/* Logo */}
        <Col lg={1} sm={3} xs={"auto"} className="mr-auto ps-0 fdd">
          <Link aria-label="header logo" className="flex items-center" to="/">
            <Navbar.Brand className="inline-block p-0 m-0">
              <img crossorigin="anonymous" className="default-logo" width="111" height="60" src={IMAGE_PATHS.LOGO} alt="logo" />
              <img crossorigin="anonymous" className="alt-logo" width="111" height="60" src={IMAGE_PATHS.LOGO} alt="logo" />
            </Navbar.Brand>
          </Link>
        </Col>
        {(location.pathname !== '/reviews' || showSearchBar) && (
          <Col lg={5} xs={"auto"} className="justify-end pe-0 flex items-center sdff">
            {/* Search Input */}

            <div className="w-[100%] flex rounded-full  shadowla1 bg-white relative overflow-visible leading-[1.7] md:hidden">
              {/* Search */}
              <div className="flex-1 relative">
                <input
                  type="text"
                  placeholder="Search To Review"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onKeyDown={handleKeyPress}
                  className="w-full pl-[3.5rem] pr-4 py-2 text-sm text-gray-700 placeholder-gray-400 rounded-l-full custom-placeholder"
                />
                <div className="absolute inset-y-0 left-[1.5rem] flex items-center pointer-events-none ">
                  <svg
                    viewBox="0 0 24 24"
                    width="20px"
                    height="20px"
                    className="text-gray-400"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M10.12 4.14a5.99 5.99 0 1 0 0 11.98 5.99 5.99 0 0 0 0-11.98m-7.49 5.99a7.49 7.49 0 1 1 13.299 4.728L21.37 20.3l-1.06 1.061-5.44-5.44A7.49 7.49 0 0 1 2.63 10.13"
                    />
                  </svg>
                </div>
              </div>

              {/* Dropdown */}
              <hr class="h-[24px] border border-[#caccd4] relative top-[7px]" />
              <div className="relative flex items-center justify-between px-4 py-2 rounded-r-full w-[35%] md:w-[43%] xs:w-[32%]" onClick={() => setShowDropdown(!showDropdown)}
                ref={dropdownRef}>
                <span className="text-[13px] font-medium text-[#757575]">{selectedCategory}</span>
                <svg
                  className="w-4 h-4 ml-2 text-gray-500"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                </svg>

                {showDropdown && (
                  <ul className="absolute top-full right-0 mt-2 w-60 bg-white border border-gray-200 shadow-xl rounded-xl text-sm z-[9999] py-2">
                    {["Name", "Contact", "Company", "School/College", "Location"].map((item) => (
                      <li
                        key={item}
                        className={`px-4 py-2 hover:bg-gray-100 cursor-pointer ${item === selectedCategory ? "font-semibold text-gray-600" : ""}`}
                        onClick={() => {
                          setSelectedCategory(item);
                          setShowDropdown(false);
                        }}
                      >
                        {item}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
            <SearchBar className="xs:pl-[15px] order-last d-lg-none" />
          </Col>
        )}

        {/* Navbar Toggle */}
        <Navbar.Toggle className="order-last md:ml-[17px] md:px-[15px] sm:px-0">
          <span className="navbar-toggler-line"></span>
          <span className="navbar-toggler-line"></span>
          <span className="navbar-toggler-line"></span>
          <span className="navbar-toggler-line"></span>
        </Navbar.Toggle>

        {/* Navigation Menu */}
        <Navbar.Collapse className="justify-end col-auto col-lg-5 sm:z-[4]">
        <Menu className="md:hidden" data={menuData} {...props} />
        
        <MobileMenu
            className="order-last d-lg-none"
            type="modern"
            data={menuData}
            userData={jwtTokenJobcritic ? userData : null} // Pass userData directly
            onLogout={jwtTokenJobcritic ? handleLogout : null} // Pass handleLogout directly
            {...props}
          />
        </Navbar.Collapse>
        {jwtTokenJobcritic  ? (
        <HeaderNot />
      ) : (<></>
      )}
        {/* Buttons and User Avatar */}
        <Col lg={"auto"} xs={"auto"} className={`justify-end pe-0 flex items-center  ${jwtTokenJobcritic ? "" : "top-[5px]"}`}>


          {jwtTokenJobcritic ? (
            <div className="d-none d-lg-block" userData={userData}>{renderUserDropdown()}</div>
          ) : (
            <Dropdown
              className=""
              show={showMenu}
              onMouseEnter={() => setShowMenu(true)}
              onMouseLeave={() => setShowMenu(false)}
            >
              <Dropdown.Toggle
                className="btn-explore-yellow flex items-center gap-2"
                as="div"
                id="login-dropdown"
              >
                <span className="mr-[5px]">Login</span>
                <i
                  className={`fas fa-angle-down text-xs transition-transform duration-300 ${showMenu ? 'rotate-180' : 'rotate-0'
                    }`}
                ></i>
              </Dropdown.Toggle>

              <Dropdown.Menu className="bg-white shadow-lg rounded-lg w-[210px] md:w-[150px] sm:!left-[-20px] md:!left-[-16px] !pl-0 !pr-0 !pt-0 !left-[-138px]">
                <div className="bg-gray-100 w-full px-3 py-2 ja leading-[1]">
                  <span className="text-gray-700 text-sm font-semibold">
                    Welcome
                  </span>
                </div>
                <Dropdown.Item as={Link} to="/login" className="block text-gray-800 tetyel mt-[12px]">
                  Professionals
                </Dropdown.Item>
                <Dropdown.Item as={Link} onClick={() => {
                  localStorage.clear(); // Clear local storage
                  window.location.href = "/business-login"; // Redirect manually
                }}
                  className="block text-gray-800 tetyel">
                  Organizations
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )}
        </Col>
       

      </HeaderNav>
      {/* {(location.pathname !== '/reviews' || showSearchBar) && (
        <HeaderNav theme="light" expand="lg" className="py-[0px] px-[35px] lg:px-[15px] md:px-[15px] md:py-[15px] sm:px-0 f_none !pt-[2px]">
          <SearchHeaderForMob />
        </HeaderNav>
        
      )} */}
    </Header>
  );
};

export default MyHeader;
